export default __webpack_public_path__ + "static/media/dashboard_prescription_icon.0ef712e8.svg";